import { createAsyncAction, createStandardAction } from 'typesafe-actions';

import { UserSession, UserSettings } from '../../Models';
import { UserNotice } from './reducer';

const USER_PROFILE_UPDATE_INFO = 'USER_PROFILE_UPDATE_USER_INFO';
const USER_PROFILE_CLEAR_INFO = 'USER_PROFILE_CLEAR_INFO';
const USER_PROFILE_FROM_UPDATE_EXTERNAL_SOURCE = 'UPDATE_USER_PROFILE_FROM_EXTERNAL_SOURCE';

const USER_PROFILE_LOAD = 'USER_PROFILE_LOAD';
const USER_PROFILE_LOAD_ERROR = 'USER_PROFILE_LOAD_ERROR';

const USER_PROFILE_LOG_OUT_CLICK = 'USER_PROFILE_LOG_OUT_CLICK';
const USER_PROFILE_DELETE_ACCOUNT_CLICK = 'USER_PROFILE_DELETE_ACCOUNT_CLICK';

const USER_PROFILE_DELETE_ALL_PAGES_BUTTON_CLICK = 'USER_PROFILE_DELETE_ALL_PAGES_BUTTON_CLICK';

const USER_PROFILE_CHANGE_CHANGE_PASSWORD_FORM_SUBMIT = 'USER_PROFILE_CHANGE_CHANGE_PASSWORD_FORM_SUBMIT';

export const updateUserProfileInfo = createStandardAction(USER_PROFILE_UPDATE_INFO)<UserSession>();
export const clearUserProfileInfo = createStandardAction(USER_PROFILE_CLEAR_INFO)();

export const updateUserProfileFromExternalSource = createStandardAction(USER_PROFILE_FROM_UPDATE_EXTERNAL_SOURCE)<
  any
>();

export const reloadUserProfile = createStandardAction('USER_PROFILE_RELOAD')();
export const loadUserProfile = createStandardAction(USER_PROFILE_LOAD)();

export const syncUserProfile = createAsyncAction('@user/sync#request', '@user/sync#success', '@user/sync#error')<
  any,
  UserSession,
  Error
>();

export const loadUserProfileError = createStandardAction(USER_PROFILE_LOAD_ERROR)<string>();

export const clickUserProfileLogout = createStandardAction(USER_PROFILE_LOG_OUT_CLICK)();

export const clickUserProfileDeleteAllPagesButton = createStandardAction(USER_PROFILE_DELETE_ALL_PAGES_BUTTON_CLICK)<
  string
>();

export const deleteAllPagesData = createAsyncAction(
  'USER_PROFILE_DELETE_ALL_PAGES_DATA_REQUEST',
  'USER_PROFILE_DELETE_ALL_PAGES_DATA_SUCCESS',
  'USER_PROFILE_DELETE_ALL_PAGES_DATA_ERROR',
)<any, any, Error>();

export const deleteAccount = createAsyncAction(
  'USER_PROFILE_DELETE_ACCOUNT_REQUEST',
  'USER_PROFILE_DELETE_ACCOUNT_SUCCESS',
  'USER_PROFILE_DELETE_ACCOUNT_ERROR',
)<any, any, Error>();

export const deleteAccountClick = createStandardAction(USER_PROFILE_DELETE_ACCOUNT_CLICK)<string>();

export const changeUserPassword = createAsyncAction(
  'USER_PROFILE_CHANGE_PASSWORD_REQUEST',
  'USER_PROFILE_CHANGE_PASSWORD_SUCCESS',
  'USER_PROFILE_CHANGE_PASSWORD_ERROR',
)<any, any, Error>();

export const submitChangeUserPasswordForm = createStandardAction(USER_PROFILE_CHANGE_CHANGE_PASSWORD_FORM_SUBMIT)<
  any
>();

export const changeUserWordsGoal = createAsyncAction(
  'USER_PROFILE_CHANGE_WORDS_GOAL_REQUEST',
  'USER_PROFILE_CHANGE_WORDS_GOAL_SUCCESS',
  'USER_PROFILE_CHANGE_WORDS_GOAL_ERROR',
)<any, any, Error>();

export const updateUserSettings = createStandardAction('@user/updateSettings')<UserSettings>();

export const submitChangeWordsGoalForm = createStandardAction('USER_PROFILE_CHANGE_WORDS_GOAL_FORM_SUBMIT')<any>();

export const cancelGumroadSubscription = createAsyncAction(
  '@user/cancelSubscription/request',
  '@user/cancelSubscription/success',
  '@user/cancelSubscription/error',
)<any, any, Error>();

export const cancelSubscription = createStandardAction('@user/cancelSubscription')();

interface SetUserNoticePayload {
  type: UserNotice;
  value: boolean;
}

export const setUserNotice = createStandardAction('@user/setNotice')<SetUserNoticePayload>();

export const syncUserProfileWithServer = createStandardAction('@user/syncWithServer')();



// WEBPACK FOOTER //
// ./src/containers/UserProfile/actions.ts